// extracted by mini-css-extract-plugin
module.exports = {"Sparks":"sparks_Sparks__mfhjv"};